<template>
    <div>

        <div v-if="editInstituicaoSuperior && !dados.id" class="loading-form" style="min-height: 130px;">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <el-form @submit.native.prevent="onSubmitInstituicaoSuperior" v-if="!editInstituicaoSuperior || dados.id" :model="dados" ref="dados" label-position="top">
            <div v-if="!editInstituicaoSuperior || dados.id">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="4" :md="4">
                        <el-form-item label="Situação" prop="situacao" :rules="[$requiredChange]" key="situacao">
                            <el-select v-model="dados.situacao" clearable>
                                <el-option :key="true" label="ATIVO" :value="true"></el-option>
                                <el-option :key="false" label="INATIVO" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="3" :md="3">
                        <el-form-item label="Código Censo" prop="cod_censo" :rules="[$requiredBlur]" key="cod_censo">
                            <el-input v-model="dados.cod_censo" maxlength="191" v-mask="'####'" v-on:blur="formatData('cod_censo')" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="17" :md="17">
                        <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]" key="nome">
                            <el-input v-model="dados.nome" maxlength="191" v-on:blur="formatData('nome')" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>  

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="3" :md="3">
                        <el-form-item label="Código UF" prop="cod_uf" :rules="[$requiredBlur]" key="cod_uf">
                            <el-input v-model="dados.cod_uf" maxlength="191" v-mask="'####'" v-on:blur="formatData('cod_uf')" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="3" :md="3">
                        <el-form-item label="Código Município" prop="cod_municipio" :rules="[$requiredBlur]" key="cod_municipio">
                            <el-input v-model="dados.cod_municipio" maxlength="191" v-mask="'####'" v-on:blur="formatData('cod_municipio')" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="3" :md="3">
                        <el-form-item label="Cód. Depend. Adm." prop="cod_dependencia_adm" :rules="[$requiredBlur]" key="cod_dependencia_adm">
                            <el-input v-model="dados.cod_dependencia_adm" title="Código da Dependência Administrativa" maxlength="191" v-mask="'####'" v-on:blur="formatData('cod_dependencia_adm')" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="5" :md="5">
                        <el-form-item label="Nome Dependência Adminstrativa" prop="nome_dependencia_adm" :rules="[$requiredChange]" key="nome_dependencia_adm">
                            <el-select v-model="dados.nome_dependencia_adm" clearable>
                                <el-option key="FEDERAL" label="FEDERAL" value="FEDERAL"></el-option>
                                <el-option key="ESTADUAL" label="ESTADUAL" value="ESTADUAL"></el-option>
                                <el-option key="MUNICIPAL" label="MUNICIPAL" value="MUNICIPAL"></el-option>
                                <el-option key="PRIVADA" label="PRIVADA" value="PRIVADA"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="5" :md="5">
                        <el-form-item label="Tipo de Instituição" prop="tipo" :rules="[$requiredChange]" key="tipo">
                            <el-select v-model="dados.tipo" clearable>
                                <el-option key="PÚBLICA" label="PÚBLICA" value="PÚBLICA"></el-option>
                                <el-option key="PRIVADA" label="PRIVADA" value="PRIVADA"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="5" :md="5">
                        <el-form-item label="Condição de Funcionamento" prop="condicao_funcionamento" :rules="[$requiredChange]" key="condicao_funcionamento">
                            <el-select v-model="dados.condicao_funcionamento" clearable>
                                <el-option :key="true" label="ATIVA" :value="true"></el-option>
                                <el-option :key="false" label="INATIVA" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>  

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item class="u-text-right u-mt-15">
                            <el-button type="primary" id="btn-instituicao-superior" native-type="submit">SALVAR</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>

    </div>
</template>
<script>

export default {
    props: ['paramId'],
    data: () => ({
        editInstituicaoSuperior: false,
        alert: false,
        dados: {
            id: '',
            situacao: '',
            nome: ''
        }

    }),
    mounted () {

    },
    methods:{
        getInstituicaoSuperiorById(id){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/ensino-superior-instituicao/getById/` + id, this.$store.getters.getHeaderAuth).then(response => {

                this.dados = JSON.parse(JSON.stringify(response.data));
 
            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        onSubmitInstituicaoSuperior(){

            document.getElementById("btn-instituicao-superior").focus();

            this.$refs.dados.validate((valid) =>{ if(valid){
 
                window.eventBus.$emit('loading', true);                

                if(this.editInstituicaoSuperior){

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/ensino-superior-instituicao/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(response => {

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        
                        this.$emit('onSubmitInstituicaoSuperior');

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }else{

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/ensino-superior-instituicao/store`, this.dados, this.$store.getters.getHeaderAuth).then(response => {
                    
                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

                        this.$emit('onSubmitInstituicaoSuperior');

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        resetFormInstituicaoSuperior(){
          
            this.dados = { id: '', nome: '', descricao: '', ativa: '', emDestaque: null, imagem: '' };
            this.$refs.dados.clearValidate();
        },
        formatData(field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA 
                        
            if(!this.dados[field])
                return false;

            if(size && this.dados[field].length < size)
                this.dados[field] = '';            

            this.dados[field] = this.dados[field].toUpperCase();

            this.dados[field] = this.$removerAcentos(this.dados[field]);
        }
    },
    watch: {
        paramId: {
            immediate: true,
            handler (value) {

                if(value){

                    this.getInstituicaoSuperiorById(value);
                    this.editInstituicaoSuperior = true;
                } 
            }
        },
    }
}
</script>
